import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    document.documentElement.className = `theme-${theme}`;
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  const colors = theme === 'dark' ? {
    bgPrimary: '#0a0a0a',
    bgSecondary: '#111111',
    bgSecondary1: '#111111',
    bgTertiary: '#1a1a1a',
    comeCard: '#1a1a1a',
    comeCard1: '#2a2a2a',
    bgTertiary1: '#1a1a1a',
    bgGradient: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
    bgGradient1: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
    bgCard: '#2a2a2a',
    bgCard2: '#2a2a2a',
    textPrimary: '#e5e5e5',
    textPrimary1: '#bbb',
    upvote: '#1a1a1a',
    header: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
    upvote1: '#1a1a1a',
    textSecondary: '#888',
    textSecondary1: '#888',
    textTertiary: '#ccc',
    accentPrimary: '#00d4aa',
    vote: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
    vote1: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
    accentPrimary1: '#00d4aa',
    accentSecondary: '#10b981',
    accentSecondary1: '#10b981',
    border: '#333',
    imgBackground: '#111',
    imgBackground1: '#111',
    imgBackground2: '#111',
    borderLight: 'rgba(255, 255, 255, 0.1)',
    filterActiveGradient: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
    filterActiveText: '#0a0a0a',
    filterActiveBorder: '#00d4aa',
    filterInactiveBackground: '#2a2a2a',
    filterInactiveText: '#e5e5e5',
    pinCard: '#fbbf24',
    filterInactiveBorder: '#333',
    filterHoverGradient: 'linear-gradient(135deg, rgba(0, 212, 170, 0.2) 0%, rgba(16, 185, 129, 0.2) 100%)',
    filterHoverBorder: '#00d4aa',
    filterHoverText: '#00d4aa',
  } : {
    bgPrimary: '#E5C687',
    bgSecondary: '#B98241',
    comeCard: '#B98241',
    comeCard1: '#B98241',
    bgSecondary1: '#E5C687',
    bgTertiary: '#936027',
    bgTertiary1: '#E5C687',
    bgGradient: 'linear-gradient(135deg, #E5C687 0%, #D4B576 100%)',
    bgGradient1: 'linear-gradient(135deg, #d89c52ff 0%, #B98241 100%)',
    bgCard: '#F5E8D8',
    bgCard2: '#F5E8D8',
    textPrimary: '#1A1A1A', 
    textPrimary1: '#1A1A1A',
    header:'linear-gradient(135deg, #B2F1B1 0%, #8FD98F 100%)',
    upvote: '#936027', 
    upvote1: '#E5C687', 
    textSecondary: '#3B2E19',
    textSecondary1: '#B2F1B1',
    textTertiary: '#222222',
    accentPrimary: '#7E8332',
    vote:'linear-gradient(135deg, #E5C687 0%, #D4B576 100%)',
    vote1:'linear-gradient(135deg, #936027 0%, #7A4E1F 100%)',
    accentPrimary1: '#B2F1B1',
    accentSecondary: '#E17230',
    accentSecondary: '#B2F1B1',
    border: '#2C3E50',
    imgBackground: '#E5C687',
    imgBackground1: '#936027',
    imgBackground2: '#B98241',
    borderLight: 'rgba(0, 0, 0, 0.1)',
    pinCard: "#7E8332",

    filterActiveGradient: 'linear-gradient(135deg, #7E8332 0%, #6A7028 100%)',
    filterActiveText: '#F5E8D8',
    filterActiveBorder: '#7E8332',
    filterInactiveBackground: '#F5E8D8',
    filterInactiveText: '#1A1A1A',
    filterInactiveBorder: '#2C3E50',
    filterHoverGradient: 'linear-gradient(135deg, rgba(126, 131, 50, 0.2) 0%, rgba(106, 112, 40, 0.2) 100%)',
    filterHoverBorder: '#7E8332',
    filterHoverText: '#7E8332',
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, colors }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);